const profileStatements = [
  {
    statement: 'Passionate front-end developer who loves crafting user-centric web interfaces with React and Tailwind CSS.',
  },
  {
    statement: 'Creative developer focused on building responsive, intuitive, and accessible web applications using modern JavaScript frameworks.',
  },
  {
    statement: 'Front-end enthusiast with a sharp eye for UI details and a drive to deliver seamless user experiences.',
  },
  {
    statement: 'Driven by clean code and sleek design, I build scalable web interfaces with React, TypeScript, and Tailwind CSS.',
  },
  {
    statement: 'Developer who turns designs into fully functional and elegant interfaces, ensuring performance and usability.',
  },
  {
    statement: 'Enjoys transforming complex problems into clean and interactive UI solutions using React and modern CSS techniques.',
  },
  {
    statement: 'Detail-oriented front-end developer with a passion for pixel-perfect implementation and component reusability.',
  },
  {
    statement: 'Focused on delivering engaging digital experiences by combining strong UI principles with modern web technologies.',
  },
  {
    statement: 'Front-end developer who enjoys collaborating across teams to build dynamic, user-first web apps.',
  },
  {
    statement: 'Committed to writing clean, maintainable code while continuously improving web performance and UX.',
  }
];
export default profileStatements;